module.exports = __webpack_public_path__ + "static/media/statuten Stichting CR.9d50242b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf/statuten Stichting CR.pdf
// module id = 1133
// module chunks = 0